// Only route resource failures offer a reload; application/API errors keep their own handling.
export function createChunkRecovery({ confirmReload, navigate, resolveHref, origin, now = Date.now }) {
  let pending = false
  return async (error, to) => {
    const message = String((error && error.message) || '')
    if (!/ChunkLoadError|Loading (?:CSS )?chunk .+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(`${error && error.name} ${message}`) || pending) return
    pending = true
    try {
      if (!await confirmReload()) return
      const target = new URL(resolveHref(to), origin)
      if (target.origin !== origin) return
      // A fresh document also recovers when an intermediary cached the old HTML.
      target.searchParams.set('_app_reload', String(now()))
      navigate(target.href)
    } finally {
      pending = false
    }
  }
}
